module.exports = __webpack_public_path__ + "static/media/LittleWar.09cadc9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/AppDevelopment/LittleWar.png
// module id = 460
// module chunks = 0